import { getBlacklistedInfluencers } from '../../services/blacklist.service';
import { blacklistFetchLimit } from '../../utils/constants';
import { EVICT_BLACKLIST_CACHE, FETCH_BLACKLIST_SUCCESS, SET_BLACKLIST_LOADING } from './blacklistType';

export const setLoading = (loading = false) => {
  return {
    type: SET_BLACKLIST_LOADING,
    payload: loading,
  };
};

export const fetchBlacklistSuccess = (payload) => {
  return {
    type: FETCH_BLACKLIST_SUCCESS,
    payload,
  };
};

export const evictBlacklistCache = () => {
  return {
    type: EVICT_BLACKLIST_CACHE,
  };
};

export const evictBlacklistAndRefetch = () => (dispatch) => {
  dispatch(setLoading(true));
  dispatch(evictBlacklistCache());
  dispatch(fetchBlacklistedInfluencer());
};

export const fetchBlacklistedInfluencer = (args) => {
  return async (dispatch) => {
    let limit = args?.limit || blacklistFetchLimit;
    let cursor = args?.cursor || null;
    let page = args?.page || 1;
    const key = `${limit}-${page}`;
    dispatch(setLoading(true));
    const response = await getBlacklistedInfluencers({ limit, cursor });
    if (response?.status) {
      dispatch(
        fetchBlacklistSuccess({ influencer: response.data.blacklistedInfluencers, count: response.data.total, key })
      );
    } else {
      dispatch(fetchBlacklistSuccess({ influencer: [], count: 0, key }));
    }
    dispatch(setLoading(false));
  };
};
